import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcessIxHansaInvestStdBuExportStatus: 'idle',
    startProcessIxHansaInvestStdBuExportError: undefined as any,
    loadUserParamsProcessIxHansaInvestStdBuExportStatus: 'idle',
    loadUserParamsProcessIxHansaInvestStdBuExportError: undefined as any,

    processIxHansaInvestStdBuExportList: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcessIxHansaInvestStdBuExport = createAsyncThunk('processIxHansaInvestStdBuExportSlice/startProcessIxHansaInvestStdBuExport', async ({ processIxHansaInvestStdBuExport }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcessIxHansaInvestStdBuExport/`,
        prepareData(processIxHansaInvestStdBuExport),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcessIxHansaInvestStdBuExportStatus } = getState().processIxHansaInvestStdBuExportSlice
        return startProcessIxHansaInvestStdBuExportStatus !== 'pending'
    }
})

export const loadUserParamsProcessIxHansaInvestStdBuExport = createAsyncThunk('processIxHansaInvestStdBuExportSlice/loadUserParamsProcessIxHansaInvestStdBuExport', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcessIxHansaInvestStdBuExport/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcessIxHansaInvestStdBuExportStatus } = getState().processIxHansaInvestStdBuExportSlice
        return loadUserParamsProcessIxHansaInvestStdBuExportStatus !== 'pending'
    }
})

const ProcessIxHansaInvestStdBuExportSlice = createSlice({
    name: 'processIxHansaInvestStdBuExportSlice',
    initialState,
    reducers: {
        resetstartProcessIxHansaInvestStdBuExport: (state) => {
            state.job = undefined
            state.startProcessIxHansaInvestStdBuExportError = undefined
        },
        resetstartProcessIxHansaInvestStdBuExportError: (state) => {
            state.startProcessIxHansaInvestStdBuExportError = undefined
        },
        resetloadUserParamsProcessIxHansaInvestStdBuExport: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcessIxHansaInvestStdBuExportError = undefined
        },
        resetloadUserParamsProcessIxHansaInvestStdBuExportError: (state) => {
            state.loadUserParamsProcessIxHansaInvestStdBuExportError = undefined
        },
        removeFromProcessIxHansaInvestStdBuExportListById: (state, action) => {
            state.processIxHansaInvestStdBuExportList = state.processIxHansaInvestStdBuExportList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcessIxHansaInvestStdBuExportListByIds: (state, action) => {
            state.processIxHansaInvestStdBuExportList = state.processIxHansaInvestStdBuExportList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.processIxHansaInvestStdBuExportList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcessIxHansaInvestStdBuExportStatus = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.processIxHansaInvestStdBuExportList = []
            state.startProcessIxHansaInvestStdBuExportStatus = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcessIxHansaInvestStdBuExport.pending, (state) => {
            state.startProcessIxHansaInvestStdBuExportStatus = 'pending'
            state.startProcessIxHansaInvestStdBuExportError = undefined
        })
        builder.addCase(startProcessIxHansaInvestStdBuExport.fulfilled, (state, action) => {
            state.startProcessIxHansaInvestStdBuExportStatus = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcessIxHansaInvestStdBuExport.rejected, (state, action) => {
            state.startProcessIxHansaInvestStdBuExportStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcessIxHansaInvestStdBuExportError = action.error.message
            } else {
                state.startProcessIxHansaInvestStdBuExportError = action.payload
            }
        })

        builder.addCase(loadUserParamsProcessIxHansaInvestStdBuExport.pending, (state) => {
            state.loadUserParamsProcessIxHansaInvestStdBuExportStatus = 'pending'
            state.loadUserParamsProcessIxHansaInvestStdBuExportError = undefined
        })
        builder.addCase(loadUserParamsProcessIxHansaInvestStdBuExport.fulfilled, (state, action) => {
            state.loadUserParamsProcessIxHansaInvestStdBuExportStatus = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcessIxHansaInvestStdBuExport.rejected, (state, action) => {
            state.loadUserParamsProcessIxHansaInvestStdBuExportStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcessIxHansaInvestStdBuExportError = action.error.message
            } else {
                state.loadUserParamsProcessIxHansaInvestStdBuExportError = action.payload
            }
        })

    }
})

export const {
    resetstartProcessIxHansaInvestStdBuExport,
    resetstartProcessIxHansaInvestStdBuExportError,
    resetloadUserParamsProcessIxHansaInvestStdBuExport,
    resetloadUserParamsProcessIxHansaInvestStdBuExportError,
    removeFromProcessIxHansaInvestStdBuExportListById,
    removeFromProcessIxHansaInvestStdBuExportListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = ProcessIxHansaInvestStdBuExportSlice.actions
export default ProcessIxHansaInvestStdBuExportSlice.reducer
